$(document).ready(function () {
  $("body").on('click', '.cliphair-rewards .swell-post-checkout .checkout-heading .swell-referral-back-link', function (e) {
    $('.swell-post-checkout').css("display", "none");
  });

  $(document).on("change", "select#redemptionoptions", function () {
    if ($(this).children("option:selected").val()=='-1'){
      $('.swell-cart-information .swell-redeem-btn').prop('disabled',true);
    }
    else{
     $('.swell-cart-information .swell-redeem-btn').prop('disabled',false); 
    }
  });

  var next_tier = 2;
  reset();
  $(window).resize(function () {
    next_tier = 2;
    reset();
  });

  $('body').on('click', '.swell-icon-keyboard_arrow_right', function (e) {
    var tdclass = ".td";
    var tohide = tdclass + next_tier;
    if (next_tier < 4) {
      next_tier++;
      var nextToGo = tdclass + next_tier;
      $(tohide).css('display', 'none');
      $(nextToGo).css('display', 'table-cell');
      if (next_tier == 4) {
        $('.swell-icon-keyboard_arrow_right').css('opacity', '0.5');
      } else {
        $('.swell-icon-keyboard_arrow_left').css('opacity', '1');
      }
    } else {
      e.preventDefault();
    }
  });

  $('body').on('click', '.swell-icon-keyboard_arrow_left', function (e) {
    var tdclass = ".td";
    var tohide = tdclass + next_tier;
    if (next_tier > 2) {
      next_tier--;
      var previousToGo = tdclass + next_tier;
      $(tohide).css('display', 'none');
      $(previousToGo).css('display', 'table-cell');
      if (next_tier == 2) {
        $('.swell-icon-keyboard_arrow_left').css('opacity', '0.5');
      } else {
        $('.swell-icon-keyboard_arrow_right').css('opacity', '1');
      }
    } else {
      e.preventDefault();
    }
  });

  $(document).on("swell:initialized", function () {
    $('.swell-referral-loader').hide();
    var campaigns = spapi.activeCampaigns;
    campaigns.forEach(function (camp) {
      if (camp.type != "ReferralCampaign") {
        $(".swell-campaign-list").append('<li class="swell-campaign"> <div class="swell-campaign-content swell-campaign-link" data-display-mode="modal" data-campaign-id=' + camp.id + '>    <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class=' + camp.icon + '><span class="path1"></span><span class="path2"></span></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">' + camp.reward_text + '</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">' + camp.title + '</span> </div> </div> </li>');
      }
    });
    $(".swell-campaign-list").append('<li class="swell-campaign"> <div class="swell-campaign-content custom-refer-campaign"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class="swell-icon-refer-a-friend"><span class="path1"></span><span class="path2"></span></span></span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">Get £10</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">Refer a Friend</span> </div> </div> </li>');

    var redemptions = spapi.activeRedemptionOptions;
    redemptions.forEach(function (redemp) {
      $(".swell-redemption-option-list").append('<li class="redemption swell-redemption-option"> <div class="swell-redemption-option-content redemption-content swell-redemption-link" data-redemption-option-id="'+ redemp.id +'"> <div class="swell-redemption-option-cost">' + redemp.name + '</div> <div class="swell-redemption-option-value">' + redemp.cost_text + '</div> </div> </li>');
    })
    $(".custom-refer-campaign").css('cursor', 'pointer');
    $("body").on("click", ".custom-refer-campaign", function () {
      window.location.href = "/pages/refer";
    });
  });

  SwellConfig.Link.initializeLinks(".swell-register-btn, .swell-login-btn");
  SwellConfig.LocalStorage.initializeLocalStorage();

  $(document).on("swell:setup", function () {
    $('.swell-referral-loader-refer').hide();
    $('.swell-referral-loader-vip').hide();
    SwellConfig.Referral.initializeReferral(".swell-referral");
    if (spapi.customer.email) {
      getreferrals();
    }

    if ($(".swell-tier-table").length > 0) {
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".swell-tier-table");
    }
    $('.swell-post-checkout').css("display", "flex");
  });

  $(document).on("swell:referral:success", function () {
    getreferrals();
  });

  $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown) {
    if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
      $(".refer-customer-error").remove();
      $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      $("#swell-referral-refer-emails").addClass("error-border");
    }
    if (textStatus && textStatus === "Please enter a valid email address") {
      $(".refer-customer-error").remove();
      $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      $("#swell-referral-refer-emails").addClass("error-border");
    }
  });
});

(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Link = {
    initializeLinks: function (containerSelector) {
      return $(document).on("click", containerSelector, function (e) {
        var href;
        e.preventDefault();
        href = $(this).attr("href");
        localStorage.setItem("swell-location", "/pages/rewards");
        return window.location = href;
      });
    },
  };
}).call(this);

// local storage
(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.LocalStorage = {
    initializeLocalStorage: function () {
      var location;
      location = localStorage.getItem("swell-location");
      if (location && window.location.pathname === '/account') {
        localStorage.removeItem("swell-location");
        return window.location = location;
      }
    }
  };
}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "",
        referralSidebarDetailsReward: "",
        referralRegisterHeading: "<h2 class='swell-referral-heading'><span class='refer-friend-heading'>Refer A Friend</span>Give £10, Get £10</h2>",
        referralRegisterFormDetails: "Enter your email below to get started",
        referralRegisterFormEmail: "Enter email",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "<%= referralCampaign.details %>",
        referralReferHeading: "<h2 class='swell-referral-heading'><span class='refer-friend-heading'>Refer A Friend</span>Give £10, Get £10</h2>",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, Enter your friends’ emails.",
        referralReferFormEmailsDetails: "Your friends' emails (separated by commas)",
        referralReferDetails: "<%= referralCampaign.details %>",
        referralReferMediaDetails: "You can also share your link with <br> the buttons below.",
        referralShareFacebook: "Share",
        referralShareSMS: "SMS",
        referralShareTwitter: "Tweet",
        referralShareMessage: "Message",
        referralShareCopy: "Copy Link",
        referralFacebookIcon: "swell-icon-facebook-share-mob",
        referralSMSIcon: "swell-icon-sms-mob",
        referralTwitterIcon: "swell-icon-tweet-mob",
        referralMessageIcon: "swell-icon-fb-message-mob",
        referralLinkIcon: "swell-icon-copy-link-mob",
        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",
        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <%= localization.referralRegisterHeading %> <p class="swell-referral-details"><%= localization.referralRegisterDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" name="swell-referral-register-submit" id="swell-referral-register-submit"><%= localization.referralRegisterFormSubmit %></button> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <%= localization.referralReferHeading %> <p class="swell-referral-details"><%= localization.referralReferDetails %> </p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit"><%= localization.referralReferFormSubmit %></button> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails%></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-facebook-share" aria-hidden="true"></i> Share </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms" aria-hidden="true"></i> SMS </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-twitter" aria-hidden="true"></i> Tweet </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-messenger" aria-hidden="true"></i> Message </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-copy-link" aria-hidden="true"></i> Copy Link </div> </li> </ul> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"></div> <div class="swell-referral-copy-main"> <div class="swell-referral-back-link-holder"> <span class="swell-referral-back-link"></span> </div> <h2 class="swell-referral-heading"> <i class="swell-referral-heading-icon swell-icon-copy-link" aria-hidden="true"></i> Give $5 Off, Get $5 </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"><%= customer.referralLink %></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link">COPY LINK</button> <p class="swell-referral-details">Copy link and share with your friends.</p> </div> </div> </div> <div> </div> </div>'
      }
    },

    initializeReferral: function (containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    },
  };
}).call(this);

(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getCustomerTierId: function () {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function () {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function (e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function (rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function (e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function () {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if (customer_tier_id === null) {
        customer_tier_id = -1;
      }
      if (customer_tier_rank === null) {
        customer_tier_rank = 0;
      }
      current_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank);
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
      columnLength = $(".tier-table tbody tr:eq(0)").children().length;
      $tierStatusRow = $(".swell-tier-status-row");
      $tierValueRow = $(".swell-tier-values");
      encouragement = "";
      dollar_difference = "";
      for (col = k = 1, ref = columnLength - 1; 1 <= ref ? k <= ref : k >= ref; col = 1 <= ref ? ++k : --k) {
        data_id = $(".swell-tier-table tbody tr:first td:eq(" + (col - 1) + ")").first().data("tierId");
        if (data_id === customer_tier_id) {
          for (index = l = 1, ref1 = col; 1 <= ref1 ? l <= ref1 : l >= ref1; index = 1 <= ref1 ? ++l : --l) {
            $tierValueRow.find("th:eq(" + index + ")").addClass("completed");
          }
        }
        if (spapi.customer.vip_tier) {
          if (customer_tier_id === spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
            encouragement = "<div class='current-tier swell-tier-active'><div>CURRENT STATUS</div></div>";

          } else {
            encouragement = "<div class='current-tier swell-tier-active'><div>CURRENT STATUS</div>";
            if (((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100) < 0) {
              encouragement2 = "<div>Spend £0 more to earn " + next_tier.name + "</div>";
            } else {
              encouragement2 = "<div>Spend £" + (next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100 + " more to earn " + next_tier.name + "</div>";
            }
          }
        } else {
          encouragement = "<div class='current-tier swell-tier-active'><div>CURRENT STATUS</div>";
          if (((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100) < 0) {
            encouragement2 = "<div>Spend £0 more to earn " + next_tier.name + "</div>";
          } else {
            encouragement2 = "<div>Spend £" + (next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100 + " more to earn " + next_tier.name + "</div>";
          }
        }
      }

      var append_td_i;
      var tdclassno = 2;
      var tdclass = "td";
      var tdclass_append = tdclass + tdclassno;
      for (append_td_i = customer_tier_rank; append_td_i > 0; append_td_i--) {
        tdclass_append = tdclass + tdclassno;
        $tierStatusRow.append("<th scope='col' class='" + tdclass_append + "'></th>");
        tdclassno++;
      }
      tdclass_append = tdclass + tdclassno;
      tdclass_append_next = tdclass + (tdclassno + 1);

      if (spapi.customer.vip_tier) {
        if (customer_tier_id === spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
          return $tierStatusRow.append("<th scope=\"col\" class='" + tdclass_append + "'>" + encouragement + "</th>");
        } else {
          $('.swell-tier-next').html(encouragement2);
          return $tierStatusRow.append("<th scope=\"col\" class='" + tdclass_append + "'>" + encouragement + "</th>");
        }
      } else {
        $('.swell-tier-next').html(encouragement2);
        return $tierStatusRow.append("<th scope=\"col\" class='" + tdclass_append + "'>" + encouragement + "</th>");
      }
    },
    initializeDummyTier: function () {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Inspired",
        amount_spent_cents: 0,
        points_multiplier: "1.0",
        swellrequiredAmountSpent: "£0",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function () {
      var activeVipTiers = spapi.activeVipTiers;
      activeVipTiers[0].points = "£0 - £" + (((activeVipTiers[1].amount_spent_cents) / 100) - 1);
      activeVipTiers[0].multiplier = "1x";
      activeVipTiers[0].vouchers = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[0].return = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[0].promos = "";
      activeVipTiers[0].free_product = "";
      activeVipTiers[0].free_box = "";

      activeVipTiers[1].points = "£" + ((activeVipTiers[1].amount_spent_cents) / 100) + " - £" + (((activeVipTiers[2].amount_spent_cents) / 100) - 1);
      activeVipTiers[1].multiplier = "Double";
      activeVipTiers[1].vouchers = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[1].return = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[1].promos = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[1].free_product = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[1].free_box = "";

      activeVipTiers[2].points = "£" + (((activeVipTiers[2].amount_spent_cents) / 100)) + "+";
      activeVipTiers[2].multiplier = "Triple";
      activeVipTiers[2].vouchers = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[2].return = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[2].promos = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[2].free_product = "<div class='swell-icon-shape-587-copy-4'></div>";
      activeVipTiers[2].free_box = "<div class='swell-icon-shape-587-copy-4'></div>";
    },
    initializeTiers: function (containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          points: {
            className: "swell-tier-values",
            title: ""
          },
          name: {
            className: "swell-tier-names",
            title: "Benefits"
          }
        },
        body: {
          multiplier: {
            title: "Point multiplier"
          },
          vouchers: {
            title: "Redeemable vouchers"
          },
          return: {
            title: "30 days returns & exchanges"
          },
          promos: {
            title: "Exclusive member only sale/promos"
          },
          free_product: {
            title: "One-time free hair care product"
          },
          free_box: {
            title: "One-time free full hair care box"
          },
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        var tdclassno = 1;
        var tdclass = "td";
        var tdclass_append = null;
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function (tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\" class=\"" + tdclass_append + "\">" + tier[key] + "</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        var tdclassno = 1;
        var tdclass = "td";
        var tdclass_append = null;
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <td scope=\"row\">" + property.title + "</td>\n</tr>");
        tiers.forEach(function (tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\" class=\"" + tdclass_append + "\" >" + tier[key] + "</td>");
        });
        i++;
        reset();
      }
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
      reset();
    }
  }
}).call(this);

function reset() {
  $('.arrows-image-left').css('opacity', '0.5');
  check_window();
}

function check_window() {
  if ($(window).width() < 768) {
    $(".td2").css("display", "table-cell");
    $(".td3").css("display", "none");
    $(".td4").css("display", "none");
  } else {
    $(".td2").css("display", "table-cell");
    $(".td3").css("display", "table-cell");
    $(".td4").css("display", "table-cell");
  }
}

function getreferrals() {
  $('.table-data').html("");
  swellAPI.refreshCustomerDetails(function () {
    var recep = spapi.customer.referral_receipts;
    recep.forEach(function (rec) {
      var em = rec.email;
      var stat = rec.completed_at;
      if (stat) {
        $('.table-data').append("<tr> + <td>" + rec.email + "</td> <td> purchased £10 (earned) </td> </tr>");
      } else {
        $('.table-data').append("<tr> + <td>" + rec.email + "</td> <td> invited </td> </tr>");
      }
    });
  });
};
